













import { defineComponent } from "@vue/composition-api";
import { ContentFile } from "@scrile/api-provider/dist/api/ContentFilesProvider";
import { getElement } from "@/lib/elementHelpers";
import { getStereoFormat, isStereoFile } from "@/lib/fileHelpers";

interface HTMLDL8VideoElement extends HTMLVideoElement {
  start: () => void;
}

export default defineComponent({
  name: "StereoVideo",
  props: {
    file: { type: Object as () => ContentFile, required: true },
    src: { type: String, required: true },
  },
  computed: {
    useStereoPlayer(): boolean {
      return isStereoFile(this.file);
    },
    stereoFormat(): string {
      return getStereoFormat(this.file);
    },
  },
  methods: {
    blockInterface() {
      this.$emit("lockFullScreen", true);
    },
    unblockInterface() {
      setTimeout(() => this.$emit("lockFullScreen", false));
    },
  },
  mounted() {
    if (this.useStereoPlayer) {
      const el = getElement<HTMLDL8VideoElement>(this.$refs.player);
      el.start();
      el.addEventListener("play", this.blockInterface);
      document.addEventListener("x-dl8-evt-did-exit", this.unblockInterface);
    }
  },
  async beforeDestroy() {
    if (this.useStereoPlayer) {
      getElement<HTMLDL8VideoElement>(this.$refs.player).removeEventListener("play", this.blockInterface);
      document.removeEventListener("x-dl8-evt-did-exit", this.unblockInterface);
    }
  },
});
